<template>
  <div>
    <base-loading :visible="isLoading" /> 
    <assign-document :documents="documentCatalog" v-model="assignDocumentModal" :title="$t('assign') + ' ' + $t('document')" @submit="AddDocument"/>
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-full md:col-span-2 md:col-start-1  xs:col-start-1">
        <vs-button color="success" icon="note_add" @click="assignDocumentModal = true"> {{ $t('assign') | capitalize }} </vs-button>
      </div>
      <div class="col-span-full md:col-span-2 md:col-start-11  xs:col-start-1">
        <search-input v-model="search" @search="onSearch" @clear="onSearch" />
      </div>
      <div class="col-span-full col-start-1">
        <vendor-documents-table :items="items" @loadMore="loadMore" @sortChanged="onSortChanged" @details="onDetails"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useDocuments } from '../composables/use-vendor-documents'
import { useNotifier } from '@/composables/useNotifier'
import { useNavigator } from '@/composables/useNavigator'
import VendorDocumentsTable from '../components/VendorDocumentsTable'
import AssignDocument from '../components/AssignDocument'
import BaseLoading from '@/views/app/components/BaseLoading'
import SearchInput from '@/views/app/components/SearchInput'

const { notify } = useNotifier()
const { goTo, getParam } = useNavigator()
const search = ref('')
const documents = useDocuments()
const sort = ref({})
const vendor = getParam('vendor')
const items = computed(() => documents.state.items)
const currentPage = computed(() => documents.state.currentPage)
const lastPage = computed(() => documents.state.lastPage)
const isLoading = computed(() => documents.state.loading)
const documentCatalog = ref([])
const assignDocumentModal = ref(false)

const loadData = async (params = {}) => {
  const payload = {
    vendorId:vendor.value,
    page: documents.state.currentPage || 1,
    search: search.value,
    column: sort.value.column,
    order: sort.value.order,
    ...params
  }
  const result = await documents.getVendorDocuments(payload)
  if (!result.success) notify({ title: 'error', text: 'message_error', color: 'danger' })
}

const loadMore = async () => {
  if (currentPage.value >= lastPage.value) return
  const newPage = documents.state.currentPage + 1
  await loadData({ page: newPage })
}

const onSearch = async () => {
  await loadData({ page: 1, search: search.value })
}

const onSortChanged = async (sortData) => {
  sort.value.column = sortData.key
  sort.value.order = sortData.order
  await loadData({ column: sort.value.column, order: sort.value.order, page: 1 })
}

const getDocumentCatalog = async () => {
  const payload = { id: 1 }
  const result = await documents.getDocumentCatalog(payload)
  if (!result.success) {
    notify({ title: 'attention', text: 'message_error', color: 'warning' })
    return
  }
  documentCatalog.value = [...result.response.documents]
}

const AddDocument = async (data) => {
  const exist = items.value.some( doc => doc.documentId == data.documentId)
  if (exist) {
    notify({ title: 'attention', text: 'message_error', color: 'warning' })
    return
  }
  const payload = { vendorId:vendor.value, documentId:data.documentId}
  const result = await documents.vendorDocumentStore(payload)
   if (!result.success) {
    notify({ title: 'attention', text: 'message_error', color: 'warning' })
    return
  }
  assignDocumentModal.value = false
}

const onDetails = (row) => {
  goTo({ name: 'rps-document-requests', params: { document: row.id } })
}

onMounted(() => {
  loadData() 
  getDocumentCatalog()
})

</script>
